import styled from 'styled-components';

export const StyledH1 = styled.h1`
    color: #444444;
    font-size: 38px;
    font-weight: bold;
    line-height: 45px;
`;
